import React, { useContext, useState } from 'react';

import { 
    HttpMethods,
    FetchContext,
    ApiRoutes,
    InsightContext 
} from '../../contexts';

import { useAggregatedState, RequestStatus } from '../../../helpers';

export const HomeContext = React.createContext(null);

const { Provider } = HomeContext;
export const HomeProvider = (props) => {
    const { fetchAuthorized } = useContext(FetchContext);
    const { trackError } = useContext(InsightContext);

    const [state, setState] = useAggregatedState({
        runningRequests:[],
        toDos: [],
        stats: [],
        involved: []
    });

    const [isLoadingRequests, setIsLoadingRequests] = useState(false);
    const loadRequests = async () => {        
        try {
            setIsLoadingRequests(true);

            const response = await fetchAuthorized(
                ApiRoutes.Request.GetRunningRequests({ pageIndex: 0, pageSize: 5 }),
                { method: HttpMethods.GET }
            );

            const runningRequests = (await response.json()).items;

            const involved = runningRequests.map(x => ({
                customerRequestId: x.customerRequestId,
                isLoading: false,
                users: null
            }));

            setState({ runningRequests, involved });
        }
        catch(e) {
            console.error(e);
            trackError(e);
        }
        finally {
            setIsLoadingRequests(false);
        }
    };

    const [isLoadingToDos, setIsLoadingToDos] = useState(false);
    const loadToDos = async () => {
        try {
            setIsLoadingToDos(true);    

            const result = await fetchAuthorized(
                ApiRoutes.User.GetUserTodos(),
                { method: HttpMethods.GET }
            );
            
            const toDos = await result.json();
            setState({ toDos });
            setIsLoadingToDos(false);
        }
        catch(error){
            console.error(error);
            trackError(error);
            setIsLoadingToDos(false);
        }
    }

    const [isLoadingStats, setIsLoadingStats] = useState(false);
    const loadStats = async () => {
        try{
            setIsLoadingStats(true);

            const response = await fetchAuthorized(
                ApiRoutes.User.GetUserStatistics(),
                { method: HttpMethods.GET }
            );
            
            const stats = await response.json();
            setState({ stats });
            setIsLoadingStats(false);
        }
        catch(e){
            console.error(e);
            trackError(e);
            setIsLoadingToDos(false);
        }
    };
    
    const isLoadingInvolvedUsers = (customerRequestId) => {        
        const item = state.involved.find(x => x.customerRequestId === customerRequestId);
        return item && item.isLoading;
    }

    const loadInvolvedUsers = async (customerRequestId, customerRequestStatus, dbType) => {
        const setIsLoadingInvolvedUsers = (customerRequestId, isLoading) => {
            const involved = [].concat(state.involved);
            const item = involved.find(x => x.customerRequestId === customerRequestId);
            item.isLoading = isLoading;
            setState({ involved });
        };
        
        try {
            setIsLoadingInvolvedUsers(customerRequestId, true);

            const response = await fetchAuthorized(
                ApiRoutes.User.GetInvolvedUsers({
                    customerRequestId,
                    onlyMissingUsers: customerRequestStatus === RequestStatus.Logistic,
                    dbType
                }),
                { method: HttpMethods.GET }
            );
            
            const users = await response.json();                    
            const involved = [].concat(state.involved).filter(x => x.customerRequestId !== customerRequestId);
            const item = { customerRequestId, isLoading: false, users };
            involved.push(item);
            setState({ involved });            
        }
        catch(e) {
            console.error(e);
            trackError(e);
            setIsLoadingInvolvedUsers(customerRequestId, true);
        }
    };

    const hasLodedInvolvedUsers = (customerRequestId) => {
        const item = state.involved.find(x => x.customerRequestId === customerRequestId);
        return item !== undefined && item !== null && (item.isLoading || item.users !== null);
    };

    const getInvolvedUsers = customerRequestId => {
        const item = state.involved.find(x => x.customerRequestId === customerRequestId);

        if (!item)
            return [];

        return item.users;
    };

    return (
        <Provider value={{
            state,
            setState,

            loadRequests,
            loadToDos,
            loadStats,

            isLoadingRequests,
            isLoadingToDos,
            isLoadingStats,

            loadInvolvedUsers,
            hasLodedInvolvedUsers,
            isLoadingInvolvedUsers,
            getInvolvedUsers

        }}>
            {props.children}
        </Provider>
    );
}